
import axois from '../utils/axiosExport'
 
// 查询收货地址列表
export function addressList(data?: any) {
  return axois.request({
    url: `/admin/delivery-address/list`,
    method: "get",
    data: {
      ...data,
    },
  });
} 
// 删除收货地址
export function addressDelete(data?: any) {
  return axois.request({
    url: `/admin/delivery-address/delete/${data.id}`,
    method: "DELETE",
    // data: {
    //   ...data,
    // },
  });
} 
// 新增收货地址
export function addressAdd(data?: any) {
  return axois.request({
    url: `/admin/delivery-address/add`,
    method: "post",
    data: {
      ...data,
    },
  });
}  
// 修改收货地址
export function addressUpdate(data?: any) {
  return axois.request({
    url: `/admin/delivery-address/update`,
    method: "post",
    data: {
      ...data,
    },
  });
}